"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("./style.scss");

var _default = {
  name: 'FeFooter',
  render: function render(h) {
    var footerDefault = h("div", {
      "class": "footer-bd"
    }, ["Copyright \xA9 2021 ", h("a", {
      "attrs": {
        "href": "https://github.com/fe-admin/fe-admin"
      }
    }, ["fe-admim"])]);
    return h("div", {
      "class": "footer"
    }, [this.$slots.default ? this.$slots.default : footerDefault]);
  }
};
exports.default = _default;